import useResizeObserver from "use-resize-observer";
import { css } from "@emotion/react";

import Menu from "components/DesignComponents/Menu";

import SettingsContent from "./SettingsContent";
import { SettingsMenuDesktopProps } from "./types";

const SettingsMenuDesktop = ({
    anchorEl,
    close,
    openDialog
}: SettingsMenuDesktopProps) => {
    const { ref, height } = useResizeObserver<HTMLElement>({});

    return (
        <Menu
            ref={ref}
            open={Boolean(anchorEl)}
            onClose={close}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right"
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right"
            }}
            slotProps={{
                list: {
                    disableListWrap: true
                }
            }}
            css={css({
                "& .MuiMenu-paper": {
                    width: "315px",
                    overflowY: "hidden"
                }
            })}
        >
            <SettingsContent
                menuPaperHeight={height}
                openDialog={openDialog}
                closeMenu={close}
            />
        </Menu>
    );
};

export default SettingsMenuDesktop;
